import React from 'react'
import styled from 'styled-components'

const Button = styled.button`
  background: none;
  border: none;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  gap: 3px;
  border-radius: 50%;
  width: 25px;
  height: 25px;

  &:hover {
    background-color: #e8e8e8;
  }
`

const Dot = styled.span`
  height: 4px;
  width: 4px;
  background-color: #56565a;
  border-radius: 50%;
  display: block;
`

function ThreeDotsButton({ ...props }) {
  return (
    <Button {...props}>
      <Dot />
      <Dot />
      <Dot />
    </Button>
  )
}

export default ThreeDotsButton
